<section
  class="border-accent-border bg-surface flex flex-col gap-2 rounded-md border p-3"
  (keydown.escape)="$event.stopPropagation(); cancelled.emit()">
  <p class="text-text-primary text-xs font-semibold">
    {{
      'features.data.path_filter.new_parameter_prompt.title'
        | translate
          : {
              kind:
                ('features.data.path_filter.new_parameter_prompt.kind.' + kind()
                | translate)
            }
    }}
  </p>
  <div
    [class]="
      askLabel() ? 'grid grid-cols-1 gap-2 sm:grid-cols-2' : 'grid grid-cols-1 gap-2'
    ">
    <input
      #nameField
      class="form-input rounded-xs font-mono"
      autocomplete="off"
      [attr.aria-label]="'features.data.path_filter.new_parameter_prompt.name' | translate"
      [placeholder]="'features.data.path_filter.new_parameter_prompt.name' | translate"
      [value]="name()"
      (input)="name.set($any($event.target).value)"
      (keydown.enter)="$event.preventDefault(); create()" />
    @if (askLabel()) {
      <input
        class="form-input rounded-xs"
        autocomplete="off"
        [attr.aria-label]="
          'features.data.path_filter.new_parameter_prompt.label' | translate
        "
        [placeholder]="'features.data.path_filter.new_parameter_prompt.label' | translate"
        [value]="label()"
        (input)="label.set($any($event.target).value)"
        (keydown.enter)="$event.preventDefault(); create()" />
    }
  </div>
  @if (name() !== '' && nameError(); as error) {
    <p class="text-danger text-xs" role="alert">
      {{
        'features.data.path_filter.new_parameter_prompt.name_' + error
          | translate
            : {
                name: name(),
                taken:
                  ('features.data.path_filter.new_parameter_prompt.kind.' + takenKind()
                  | translate),
                kind:
                  ('features.data.path_filter.new_parameter_prompt.kind.' + kind()
                  | translate)
              }
      }}
    </p>
  }
  <div class="flex items-center justify-end gap-2">
    <button type="button" class="btn btn-cancel btn-sm" (click)="cancelled.emit()">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary btn-sm disabled:cursor-not-allowed disabled:opacity-60"
      [disabled]="nameError() !== null"
      (click)="create()">
      {{ 'features.data.path_filter.new_parameter_prompt.create' | translate }}
    </button>
  </div>
</section>
